"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Journey = /*#__PURE__*/function () {
  function Journey(client) {
    (0, _classCallCheck2["default"])(this, Journey);
    this.client = client;
    this.resourceUrl = '/journey';
  }

  (0, _createClass2["default"])(Journey, [{
    key: "getJourney",
    value: function getJourney(_ref) {
      var _this$client;

      var tabType = _ref.tabType;
      var url = this.resourceUrl;

      if (tabType) {
        url += "?tabType=".concat(tabType);
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_this$client = this.client).get.apply(_this$client, [url].concat(args));
    }
  }, {
    key: "getJourneyMetadata",
    value: function getJourneyMetadata() {
      var _this$client2;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_this$client2 = this.client).get.apply(_this$client2, ["".concat(this.resourceUrl, "/metadata")].concat(args));
    }
  }, {
    key: "getListOfGroups",
    value: function getListOfGroups() {
      var _this$client3;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return (_this$client3 = this.client).get.apply(_this$client3, ["".concat(this.resourceUrl, "/teams")].concat(args));
    }
  }, {
    key: "getJourneyByTeamId",
    value: function getJourneyByTeamId(teamId) {
      var _this$client4;

      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return (_this$client4 = this.client).get.apply(_this$client4, ["".concat(this.resourceUrl, "/teams/").concat(teamId)].concat(args));
    }
  }]);
  return Journey;
}();

exports["default"] = Journey;